<template>
<div class="chapter">
<div class="inner_page">
<p class="h2c"><a id="page_v"></a>Contents</p>
<p class="toc"><a href="#/xhtml/9780226713366_05_part1">PART IV: NARRATED TIME</a></p>
<p class="toc"><a href="#/xhtml/9780226713366_06_int">Introduction</a></p>
<p class="toc1"><a href="#/xhtml/9780226713366_07_sec1">SECTION 1: THE APORETICS OF TEMPORALITY</a></p>
<p class="toc"><a href="#/xhtml/9780226713366_08_ch1">1. The Time of the Soul and the Time of the World: The Dispute between Augustine and Aristotle</a></p>
<p class="toc"><a href="#/xhtml/9780226713366_09_ch2">2. Intuitive Time or Invisible Time? Husserl Confronts Kant</a></p>
<p class="toc"><span href="#/xhtml/9780226713366_10_ch3" title="Link target outside of Sample">3. Temporality, Historicality, Within-Time-Ness: Heidegger and the “Ordinary” Concept of Time</span></p>
<p class="toc1"><span href="#/xhtml/9780226713366_11_sec2" title="Link target outside of Sample">SECTION 2: POETICS OF NARRATIVE: HISTORY, FICTION, TIME</span></p>
<p class="toc"><span href="#/xhtml/9780226713366_12_ch4" title="Link target outside of Sample">4. Between Lived Time and Universal Time: Historical Time</span></p>
<p class="toc"><span href="#/xhtml/9780226713366_13_ch5" title="Link target outside of Sample">5. Fiction and Its Imaginative Variations on Time</span></p>
<p class="toc"><span href="#/xhtml/9780226713366_14_ch6" title="Link target outside of Sample">6. The Reality of the Past</span></p>
<p class="toc"><span href="#/xhtml/9780226713366_15_ch7" title="Link target outside of Sample">7. The World of the Text and the World of the Reader</span></p>
<p class="toc"><span href="#/xhtml/9780226713366_16_ch8" title="Link target outside of Sample">8. The Interweaving of History and Fiction</span></p>
<p class="toc"><span href="#/xhtml/9780226713366_17_ch9" title="Link target outside of Sample">9. Should We Renounce Hegel?</span></p>
<p class="toc"><span href="#/xhtml/9780226713366_18_ch10" title="Link target outside of Sample">10. Towards a Hermeneutics of Historical Consciousness</span></p>
<p class="toc"><span href="#/xhtml/9780226713366_19_con" title="Link target outside of Sample">Conclusions</span></p>
<p class="toc1"><span href="#/xhtml/9780226713366_20_notes" title="Link target outside of Sample"><em>Notes</em></span></p>
<p class="toc"><span href="#/xhtml/9780226713366_21_bib" title="Link target outside of Sample"><em>Bibliography</em></span></p>
<p class="toc"><span href="#/xhtml/9780226713366_22_index" title="Link target outside of Sample"><em>Index</em></span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780226713366_04_toc.vue?214beb5c